/** Mapping Of Known Routes */
export enum ROUTES {
	LANDING = '/',
	LOGIN = '/login',
	SIGNUP = '/signup',
	HOME = '/home',
	SETTINGS = '/settings',
	EMAIL_PENDING = '/pendingemailconfirmation',
	EMAIL_CONFIRMATION = '/confirmemail',
	RELOAD = '/reload',
	SUBSCRIBE = '/subscribe',
	AUTHENTICATE = '/authenticate',
	TEST_THEME = '/theme',	// Development style tests
}



// WEBPACK FOOTER //
// ./src/config/routes.ts